define([
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory"
], function(def,Action,ActionFactory) {

	return ActionFactory.declare("tableExpandAll", Action, {
		constructor: function() {
			this.m_id = "TableExpandAll";
			this.expandAll = true;
		},

		hasAccess: function(/*Context*/ctx) {
			// summary: disable if number of results exceeds max result size limit
			return !ctx.view.getQueryLimitIfReached() && this.inherited(arguments);
		},

		validate: function(/*Context*/ctx) {
			// summary: only available if table has hierarchy and is configured for full expansion
			var	r = ctx.defView.m_relationships;
			return ctx.defView.m_bExpandAll && r && ((r.length > 1) || r[0].m_bRepeat);
		}
	});
});